// extracted by mini-css-extract-plugin
export default {"host":"style_host__3l0Qs","item":"style_item__7IPwp","removeButton":"style_removeButton__zKngc"};